import { matchPath } from 'react-router-dom';

import { IRouteItem } from '@components/common/RoutesWrapper/interfaces';

export const ensureLeadingSlash = (path: string): string => {
	return path.startsWith('/') ? path : `/${path}`;
};

export const sliceToLocalPath = ({
	pathname,
	basePathPrefix,
	pathnameBase,
}: {
	pathname: string;
	basePathPrefix?: string;
	pathnameBase?: string;
}): string => {
	if (!basePathPrefix || !pathnameBase) {
		return pathname;
	}

	return pathname.slice(pathnameBase.length) || '/';
};

export const pickLongestMatchedRoute = ({
	routesList,
	localPathname,
}: {
	routesList: IRouteItem[];
	localPathname: string;
}): (IRouteItem & { path: string }) | undefined => {
	const normalizedLocalPath = ensureLeadingSlash(localPathname);

	const matchedRouteItems = routesList.filter(
		(routeItem): routeItem is IRouteItem & { path: string } => {
			return (
				typeof routeItem.path === 'string' &&
				routeItem.path !== '/' &&
				matchPath(
					{ path: ensureLeadingSlash(routeItem.path), end: false },
					normalizedLocalPath,
				) !== null
			);
		},
	);

	if (matchedRouteItems.length === 0) {
		return undefined;
	}

	return matchedRouteItems.reduce(
		(currentLongest, candidate) => {
			return candidate.path.length > currentLongest.path.length ? candidate : currentLongest;
		},
	);
};
